module.exports = __webpack_public_path__ + "media/images/placeholder-4cd23220f4b11a59e213c7b00ecec1b9.svg";